<template>
  <div v-if="pagination">
    <div class="shadow border-b border-gray-200 rounded-lg">
      <!-- 連結到各標本資訊頁 -->
      <div
        v-for="(specimen, index) in pagination.data"
        :key="index"
        :class="index % 2 === 0 ? 'bg-white' : 'bg-gray-200'"
        class="cursor-pointer hover:bg-blue-200 p-5"
      >
        <router-link target="_blank" :to="`/specimen/catalog/${specimen.catalog_number}`">
          <div class="flex space-x-10">
            <div class="flex-none">
              <!-- 流水號 -->
              <p class="mb-3">
                {{
                  pagination.meta.pagination.per_page *
                    (pagination.meta.pagination.current_page - 1) +
                  index +
                  1
                }}
              </p>
              <!-- 圖標(沒圖就空著) -->
              <div v-if="specimen.state_of_check === 1">
              <img src="@/assets/noImage-icon.svg" alt="圖標"/>
              </div>
            </div>
            <div>
              <div class="flex flex-wrap">
                <!-- 最新鑑定學名 -->
                <p v-html="specimen.revised_taxon" class="text-lg font-bold text-left mr-5 web-dark-color"></p>
                <!-- 中文名 -->
                <p class="text-lg font-bold mr-5 text-left web-dark-color mb-2">
                  {{ specimen.revised_taxon_tw }}
                </p>
                <p class="text-lg font-bold text-left web-dark-color mb-2">
                  {{ specimen.type_status }}
                </p>
              </div>
              <div class="flex items-center flex-wrap">
                <p class="mr-5 text-left">{{ getSpecimenCatalogNumber(specimen.catalog_number) }}</p>
                <div class="flex space-x-2 mr-5">
                  <img src="@/assets/collector.svg" alt="採集者"/>
                  <!-- 採集者 -->
                  <p class="text-left">{{ specimen.recorded_by }}</p>
                </div>
                <!-- 採集編號 -->
                <p class="mr-5 text-left">{{ specimen.record_number }}</p>
                <!-- 採集日期 -->
                <p class="text-left">{{ specimen.event_date_day }}</p>
              </div>
              <div class="flex flex-wrap">
                <!-- 國家 -->
                <p class="mr-5 text-left">{{ specimen.country }}</p>
                <!-- 縣市 -->
                <p class="mr-5 text-left">{{ specimen.county }}</p>
                <!-- 地點 -->
                <p class="text-left">{{ specimen.verbatim_locality }}</p>
              </div>
            </div>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { getSpecimenNumberPrefix } from "@/api/specimen";
import Utils from "@/utils/index";

export default {
  props: ["pagination"],

  data() {
    return {
      specimenNumberPrefix: ""
    };
  },

  async mounted() {
    this.specimenNumberPrefix = await getSpecimenNumberPrefix()
      .then((response) => {
        return response.data.prefix;
      })
      .catch((error) => {
        console.log("err", error.response);
      });
  },

  computed: {
    startItemNumber() {
      return (
        this.pagination.meta.per_page *
          (this.pagination.meta.current_page - 1) +
        1
      );
    },

    endItemNumber() {
      if (
        this.pagination.meta.current_page === this.pagination.meta.last_page
      ) {
        return this.pagination.meta.total;
      } else {
        return (
          this.pagination.meta.per_page * this.pagination.meta.current_page
        );
      }
    }
  },

  methods: {
    getSpecimenCatalogNumber(catalogNumber) {
      return this.specimenNumberPrefix + Utils.pad(catalogNumber, 6)
    },
  }
};
</script>

<style scoped>
.web-dark-color {
  color: #405d73;
}
</style>
